<template>
    <div class="page">
        <div class="header">
            <span class="left" @click="goBack">
                <i class="iconfont iconfanhui1 arrow"></i>
            </span>
            <span class="title">实人认证</span>
        </div>
        <template v-if="!userInfo.id_card_num">
            <div class="expand">
                <div class="protocol">
                    森果云深知个人信息对您而言的重要性，我们收集的个人信息将用于提供和改进服务。
                    <span class="tip" @click="checkProtocol">查看隐私协议>></span>
                </div>
                <div class="idName">身份证</div>
                <template v-if="!form.legal_representative_card_front" >
                    <!-- android -->
                    <div class="card" v-if="isAndroid()" @click="uploadLeageIdEvent">
                        <img src="~@/assets/images/upload_bg.svg" alt="">
                        <div class="tip1">点击上传身份证照片</div>
                    </div>
                    <!-- Ios -->
                    <div class="card" v-else>
                        <img src="~@/assets/images/upload_bg.svg" alt="">
                        <input type="file" accept="image/*" @change="uploadImgIDCardFront" class="fileInput"  />
                        <div class="tip1">点击上传身份证照片</div>
                    </div>
                </template>
                <!-- ios -->
                <div class="info" v-else>
                    <div class="item1">
                        <div class="left">身份证照片</div>
                        <!-- 安卓 -->
                        <div class="right" v-if="isAndroid()">
                            <div class="card" @click="uploadLeageIdEvent">
                                <img v-if="form.legal_representative_card_front" :src=" qiniuImageURLPrefix + form.legal_representative_card_front" alt="">
                                <div class="tip1">点击重新上传</div>
                            </div>
                            <div class="card" @click="uploadLeageIdEvent">
                                <img v-if="form.legal_representative_card_backend" :src="qiniuImageURLPrefix + form.legal_representative_card_backend" alt="">
                                <div class="tip1">{{ form.legal_representative_card_backend ? '点击重新上传' : '点击上传' }}</div>
                            </div>
                        </div>
                        <!-- ios -->
                        <div class="right" v-else>
                            <div class="card">
                                <img v-if="form.legal_representative_card_front" :src=" qiniuImageURLPrefix + form.legal_representative_card_front" alt="">
                                <input type="file" accept="image/*" @change="uploadImgIDCardFront" class="fileInput"  />
                                <div class="tip1">点击重新上传</div>
                            </div>
                            <div class="card">
                                <img v-if="form.legal_representative_card_backend" :src="qiniuImageURLPrefix + form.legal_representative_card_backend" alt="">
                                <input type="file" accept="image/*" @change="uploadImgIDCardBack" class="fileInput"  />
                                <div class="tip1">{{ form.legal_representative_card_backend ? '点击重新上传' : '点击上传' }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="left">姓名</div>
                        <div class="right" style="border: 0">
                            <input type="text" placeholder="请输入姓名" v-model="form.name">
                        </div>
                    </div>
                    <div class="item" @click="show = true">
                        <div class="left">身份证号码</div>
                        <div class="right" v-if="!form.idNumber" style="color: #666">请输入身份证号</div>
                        <div class="right" v-else>
                            {{ form.idNumber }}
                        </div>
                    </div>
                    <div class="item" @click="chooseTime">
                        <div class="left">身份证过期时间</div>
                        <div class="right card-time">
                            <div v-if="form.currentDate">{{ time }}</div>
                            <div v-else style="color: #666">请选择身份证过期时间</div>
                            <div>
                                <i class="iconfont iconfanhui1"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="expand bg1">
                <div class="box">
                    <img src="~@/assets/images/cardBg.svg" alt="">
                    <div class="person-info">
                        <div class="name">{{ userInfo.realname }}</div>
                        <div class="id">{{userInfo.id_card_num.slice(0, 1)}}***************{{userInfo.id_card_num.slice(-1)}}</div>
                        <div class="p-tip">
                            <div>
                                <img src="~@/assets/images/projectIcon.svg" alt="">
                            </div>
                            <div style="margin-left: 2px">个人隐私信息保障中</div>
                        </div>
                    </div>
                </div> 

                <div>
                    <div class="item-one">
                        <div>身份证照片</div>
                        <div>已上传</div>
                    </div>
                     <div class="item-one">
                        <div>人脸核验</div>
                        <div>已核验</div>
                    </div>
                </div>
            </div>
        </template>
        <div class="footer" v-if="!userInfo.id_card_num">
            <button :disabled="isCanSubimit" @click="checkoutPerson">开始人脸核验</button>
        </div>
        <iframe-dialog ref='iframeRefs' title="查看隐私协议" url="https://i.senguo.cc/bbs/privacy/5eb92b2b36fcc540"></iframe-dialog>
        <datetimepicker ref="timeRef" @myEvent="confrim" />
        <van-number-keyboard
            :show="show"
            extra-key="X"
            close-button-text="完成"
            @blur="show = false"
            @input="onInput"
            @delete="onDelete"
        />
    </div>
    
</template>

<script>
import datetimepicker from '@/components/datetimepicker/datetimepicker'
import dayjs from 'dayjs'
import { mapState } from 'vuex'
import { qiniuImageURLPrefix } from '@/config/config'
import { isAndroid } from '@/assets/js/util'
import JsBridge from '@/assets/js/js-bridge'
import { zipImage, uploadImage64 } from '@/assets/js/upload'
import store from '@/store/index'

export default {
    data: function() {
        return {
            form: {
                legal_representative_card_backend: '',
                legal_representative_card_front: '',
                name: '',
                idNumber: '',
                currentDate: '',
                living_image: ''
            },
            userInfo: {},
            show: false
        }
    },
    created() {
        this.qiniuImageURLPrefix = qiniuImageURLPrefix
        this.isAndroid = isAndroid
        this.getUserInfo()
    },
    watch: {
        imgForms: {
            handler(val){
                for (let key in val ) {
                this.form[key] = val[key]
                }
            },
            deep: true
        },
        'form.legal_representative_card_front'(val) {
            this.getFontOcr(val)
                .then( data => {
                    if (!this.form.name) this.form.name = data.result.name
                    if (!this.form.idNumber) this.form.idNumber = data.result.id_card
                })
        },

        'form.legal_representative_card_backend'(val) {
            this.getBackOcr(val)
                .then( data => {
                    if (data.result.expire_date) this.form.currentDate = dayjs(data.result.expire_date).toDate()
                })
        },

        'form.living_image'(val) {
            if (!val) return
            this.setUserInfo()
        }

    },

    computed: {
        time: function() {
            return dayjs(this.form.currentDate).format("YYYY-MM-DD")
        },
        isCanSubimit: function() {
            const form = this.form
            if (form.legal_representative_card_backend && form.legal_representative_card_front && form.name && form.idNumber.length === 18 && form.currentDate) {
                return false
            } else {
                return true
            }
        },
        ...mapState({
            imgForms: 'imgForm'
        })
    },

    methods: {
        goBack() {
            this.$router.back(-1)
        },
        checkProtocol() {
            if (isAndroid()) {
                this.$refs.iframeRefs.open()
            } else {
               window.location.href = 'https://i.senguo.cc/bbs/privacy/5eb92b2b36fcc540'
            }

        },

        setUserInfo() {
            const { legal_representative_card_backend, legal_representative_card_front, name, idNumber, currentDate, living_image  } = this.form
            this.$fetch.post({
                url: '/auth/info/set',
                params: {
                    realname: name,
                    id_card_front: legal_representative_card_front,
                    id_card_back: legal_representative_card_backend,
                    id_card_num: idNumber,
                    id_card_expire_date: dayjs(currentDate).format('YYYY-MM-DD'),
                    living_image: living_image
                }
            }).then(() => {
                this.openMessage(1, '认证成功')
                this.getUserInfo()
            }).catch((e) => {
                return this.openMessage(0, '认证失败')
            })
        },

        getUserInfo() {
            this.$fetch.post({
                url: '/auth/get',
            }).then(data => {
                this.userInfo = data.auth_info
            }, (e) => {
                this.openMessage(0, e.message || 'error')
            })
        },
        chooseTime() {
            this.$refs.timeRef.open({
                currentDate: this.form.currentDate
            })
        },
        confrim(data) {
            this.form.currentDate = data
        },
        onInput(value) {
            if (this.form.idNumber.length === 18) return
            this.form.idNumber = this.form.idNumber + value
        },
        onDelete() {
            if (!this.form.idNumber) return
            this.form.idNumber = this.form.idNumber.slice(0, -1)
        },

        checkoutPerson() {
            if (isAndroid()) {
                try{
                    window.Assistant.getLivenessImage('getLivenessImage');
                }catch(e){
                    return this.openMessage(0, '当前APP版本太低，请先前往【个人中心】更新APP')
                }
            } else {  // 其他app
                JsBridge.invokeMethod('getLivenessImage', async (str) => {
                    const url = await uploadImage64(str)
                    store.commit('SET_FORM_IMG', {
                        type: 'living_image',
                        imgStr: url,
                    })
                })
            }
        },
        uploadLeageIdEvent() {  // 上传法人认证身份证
            if (navigator.userAgent.indexOf("senguo:androidcgapp") > -1) {
                try{
                    window.NativeApi.captureIdCard('getBase64ImgFromAndroidIdcard')
                }catch(e){
                    return this.openMessage(0, '当前APP版本太低，请先前往【个人中心】更新APP')
                }
            } else {  // 其他app
                try{
                    window.Assistant.captureIdCard();
                }catch(e){
                    return this.openMessage(0, '当前APP版本太低，请先前往【个人中心】更新APP')
                }
            }
        },
        getFontOcr(str) {
            return this.$fetch.post({
                url: '/auth/id_card/front/ocr',
                params: {
                    id_card_front: str
                }
            })
        },
        getBackOcr(str) {
            return this.$fetch.post({
                url: '/auth/id_card/back/ocr',
                params: {
                    id_card_back: str
                }
            })
        },

        uploadImgIDCardFront(e) {
            const files = e.target.files || []
            const file = files[0]
            this.iosUploadImg(file, 'legal_representative_card_front')
        },

        uploadImgIDCardBack(e) {
            const files = e.target.files || []
            const file = files[0]
            this.iosUploadImg(file, 'legal_representative_card_backend')
        },

        async iosUploadImg(file, type) {
            this.openMessage(1, '正在上传！')
            try {
                let img64 = await zipImage(file)
                const url = await uploadImage64(img64)
                this.$store.commit('SET_FORM_IMG', {
                    imgStr: url,
                    type: type
                })
            } catch (e) {
                this.openMessage(0, '上传失败')
            }
        },

    },
    components: {
        datetimepicker
    }
}
</script>

<style lang="scss" scoped>
.page {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;

    .header {
        display: flex;
        align-items: center;
        width: 100%;
        height: 50px;
        background-color: #fff;
        // padding-left: 14px;

        .left {
            display: flex;
            align-items: center;
            padding-left: 14px;
            width: 50px;
            height: 50px;
            color: #999;

            &:active {
                background: rgba($color: #000000, $alpha: 0.05);
            }

            .arrow {
                color: #000;
                font-size: 24px;
                transform:rotate(180deg);
            }
        }
        
        .title {
            font-weight: bold;
            color: #000;
            // margin-left: 10px;
        }
       
    }

    .expand {
        flex: 1;
        .protocol {
            padding: 10px;
            background: #FCF6E6;
            font-size: 12px;
            color: #73550D;
            line-height: 16px;
        }

        .tip {
            color: #3c90ff;
            font-weight: bold;
        }

        .card {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 164px;
            background-color: #fff;

            .fileInput {
                position: absolute;
                width: 128px;
                height: 88px;
                opacity: 0;
            }

            &:active {
                background-color: rgba($color: #000000, $alpha: 0.05);
            }

            .tip1 {
                font-size: 14px;
                margin-top: 10px;
            }

            > img {
                width: 128px;
                height: 88px;
            }
        }

        .idName {
            margin-top: 10px;
            display: flex;
            align-items: center;
            padding-left: 10px;
            height: 32px;
            font-size: 14px;
            color: #999;
        }

        .info {
            width: 100%;
            background-color: #fff;
            padding: 0 10px;
            font-size: 14px;

            .item1 {
                display: flex;
                align-items: center;
                width: 100%;
                height: 70px;

                > .right {
                    display: flex;
                    align-items: center;
                    height: 70px;
                    flex: 1;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

                    .card {
                        position: relative;
                        margin-right: 10px;
                        width: 74px;
                        height: 50px;
                        border-radius: 3px;
                        background-color: #dbdbdb;
                        overflow: hidden;

                        > img {
                            width: 100%;
                            object-fit: cover;
                            overflow: hidden;
                        }

                        .tip1 {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            bottom: 0;
                            left: 0;
                            position: absolute;
                            width: 74px;
                            height: 14px;
                            font-size: 10px;
                            color: #fff;
                            background: rgba(0, 0, 0, 0.4);
                        }
                    }
                }
            }

            .item {
                display: flex;
                align-items: center;
                height: 50px;

                > .right {
                    display: flex;
                    align-items: center;
                    flex: 1;
                    height: 50px;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

                    > input {
                        width: 100%;
                        outline: none;
                        border: 0;
                        height: 50px;
                        border-bottom: 1px solid rgba(0, 0, 0, 0.1);

                        &:focus {
                            border-bottom: 1px solid #14cc9b;
                        }
                    }
                }

                .card-time {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    &:active {
                        background: rgba(0, 0, 0, 0.05);
                    }
                }

                .iconfanhui1 {
                    color: #999;
                }
            }

            .left {
                width: 142px;
                flex-shrink: 0;
                color: #999;
            }

        }
    }

    .box {
        position: relative;
        margin: 20px;
        height: 150px;
        overflow: hidden;

        > img {
            position: absolute;
            width: 100%;
            z-index: 0;
        }

        .person-info {
            height: 100%;
            margin: 20px;
            position: relative;
            z-index: 1;

            .name {
                font-size: 16px;
                font-weight: bold;
                color: #fff;
            }
            .id {
                margin-top: 10px;
                font-size: 14px;
                color: #fff;
            }

            .p-tip {
                display: flex;
                align-items: center;
                margin-top: 50px;
                display: flex;
                font-size: 12px;
                color: #fff;
                position: relative;
                z-index: 1;
            }
        }

        
    }

    .bg1 {
        background-color: #fff;
    }

    .item-one {
        padding:  0 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 60px;
        font-size: 14px;

        > div {
            &:nth-of-type(1) {
                color: #000;
            }
            &:nth-of-type(2) {
                color: #999;
            }
        }
    }


    .footer {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 70px;
        background: #FFFFFF;
        padding: 0 10px;
        box-shadow: 0 -1px 4px 0 rgba(0,0,0,0.06);

        > button {
            width: 100%;
            height: 50px;
            background: linear-gradient(270deg, #03D3C4 0%, #44E1A6 100%);
            border-radius: 5px;
            color: #fff;
            font-size: 16px;
            font-weight: bold;

            &:disabled {
                background: #ddd;
            }
        }
    }
}
</style>